import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const QueryUrl = `${Base_Url}/Query`;

export const GetQueryList = async (params) => {
  const { IsCompleted, ...restParams } = params; // Destructure IsCompleted from params
  const res = await postApiWithAuthorization(
    `${QueryUrl}/GetQueryList?IsCompleted=${IsCompleted}`, // Use the IsCompleted value in the URL
    restParams // Pass the rest of the parameters
  );
  return res;
};

export const UpdateQueryRemark = async (params) => {
  const res = await postApiWithAuthorization(
    `${QueryUrl}/UpdateQueryRemark`,
    params
  );
  return res;
};
export const GetQueryModel = async (KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${QueryUrl}/GetQueryModel?QueryKeyID=${KeyID}&AdminKeyID=${AdminKeyID}&UserKeyID`
  );
  return res;
};

export const UpdateQueryStatus = async (ModuleName, KeyID, AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${QueryUrl}/UpdateQueryStatus?ModuleName=${ModuleName}&QueryKeyID=${KeyID}&AdminKeyID=${AdminKeyID}`
  );
  return res;
};
